export default "__VITE_ASSET__QZPc6ox5__"